import { combine, createEffect, createEvent, createStore } from 'effector';
import { createGate } from 'effector-react';
import { pending } from 'patronum';
import { apiExportMethods } from '../../api';
import {
  CheckNotReadStatusResponse,
  ImportInterruptPayload,
  ImportInterruptResponse,
  ImportReadNotificationPayload,
  ImportReadNotificationResponse,
  Process,
  processStatuses,
  DownloadFile,
} from '../../types';
import { getBadgeColorAndNumber } from './helpers/getBadgeColorAndNumber';

export const ImportTemporalGate = createGate();

export const CHECK_NOT_READ_STATUS_TIMEOUT = 5000;

export const $notReadImports = createStore<Process[]>([]);
export const $openImportsPopperCounter = createStore(0);

export const $getBadgeColorAndNumber = combine($notReadImports, (notReadImports) =>
  getBadgeColorAndNumber(notReadImports)
);

export const $processingImports = combine($notReadImports, (notReadImports) =>
  notReadImports.filter(({ status }) => status === processStatuses.processing)
);

/** Внешнее событие для проверки экспортов.
 * Нужно запускать это событие после успешного начала экспорта в нужном разделе */
export const exportCheckNotReadStatus = createEvent();
/** Внешнее событие, срабатывающее после прочтения успешного импорта. Нужно запускать,
 * чтобы обновить таблицу после успешного импорта, если пользователь находится
 * на той же странице, где был запущен импорт */
export const refreshTableAfterSuccessImportOnSamePage = createEvent();

export const fxGetActiveExports = createEffect<void, CheckNotReadStatusResponse, Error>(
  apiExportMethods.getActiveExports
);

export const exportInterrupt = createEvent<string | number>();
export const fxExportInterrupt = createEffect<
  ImportInterruptPayload,
  ImportInterruptResponse,
  Error
>(apiExportMethods.exportInterrupt);

export const downloadFile = createEvent<DownloadFile>();
export const fxDownloadFile = createEffect<DownloadFile, ArrayBuffer, Error>(
  apiExportMethods.downloadFile
);

export const importReadNotification = createEvent<(string | number)[]>();
export const fxImportReadNotification = createEffect<
  ImportReadNotificationPayload,
  ImportReadNotificationResponse,
  Error
>(apiExportMethods.importReadNotification);

/** Передавать все эффекты раздела */
export const $isLoading = pending({
  effects: [fxGetActiveExports, fxExportInterrupt],
});
